export default __webpack_public_path__ + "83719de45247fbc6fd056240f8285e3e.svg";